import api from "@/lib/api";

export async function fetchArticles(params = {}) {
  const { data } = await api.get("/articles", { params });
  return data;
}
export async function fetchArticleFilters() {
  const { data } = await api.get("/articles/filters");
  return data;
}
export async function fetchArticle(slug) {
  const { data } = await api.get(`/articles/${slug}`);
  return data;
}
export async function adminListArticles(params = {}) {
  const { data } = await api.get("/admin/articles", { params });
  return data;
}
export async function adminCreateArticle(payload) {
  const { data } = await api.post("/admin/articles", payload);
  return data;
}
export async function adminUpdateArticle(id, payload) {
  const { data } = await api.put(`/admin/articles/${id}`, payload);
  return data;
}
export async function adminDeleteArticle(id) {
  await api.delete(`/admin/articles/${id}`);
}
